import { Box, Button, Flex, Text } from "@shared/primitive-components"
import { ReactNode } from "react"
import * as styles from "./styles"

type Props = {
  summary: string
  additionalMessage?: ReactNode
  additionalMessageOffset: boolean
  status: styles.Status
  dataTestId?: string
  onFinish: () => void
}

export const Feedback = ({
  summary,
  onFinish,
  additionalMessage,
  additionalMessageOffset,
  status,
  dataTestId,
}: Props) => (
  <Flex flexDirection="column" width="97vw" css={styles.root(status)} data-testid={dataTestId}>
    <Text css={styles.summary}>{summary}</Text>
    {additionalMessage && (
      <Box css={styles.additionalMessage(additionalMessageOffset)}>
        <Flex flexDirection="column">{additionalMessage}</Flex>
      </Box>
    )}
    <Flex justifyContent="flex-end" css={styles.buttonsWrap}>
      <Button css={styles.button} onClick={onFinish}>
        Finish
      </Button>
    </Flex>
  </Flex>
)

Feedback.defaultProps = {
  additionalMessage: undefined,
  dataTestId: undefined,
}
